import HeroSection from "@/pages/home/components/HeroSection";
import IntroSection from "@/pages/home/components/IntroSection";
import BusinessSection from "@/pages/home/components/BusinessSection";
import PhilosophyPreview from "@/pages/home/components/PhilosophyPreview";
import GroupPreview from "@/pages/home/components/GroupPreview";
import RecruitCta from "@/pages/home/components/RecruitCta";
import ContactCta from "@/pages/home/components/ContactCta";

export default function Home() {
  return (
    <div className="w-full">
      <HeroSection />
      <IntroSection />
      <BusinessSection />
      <PhilosophyPreview />
      <GroupPreview />
      <RecruitCta />
      <ContactCta />
    </div>
  );
}